module.exports = __webpack_public_path__ + "img/6.d5dc0d16.svg";